import { Action, createReducer, on } from "@ngrx/store";
import {
  clearDraftMenuState,
  saveDraftMenuState,
} from "../actions/draft.actions";

export const initialDraftState = 0;

const _draftReducer = createReducer(
  initialDraftState,
  on(
    saveDraftMenuState,
    (_state: number, newValue: { countDrafts: number }) => newValue.countDrafts,
  ),
  on(clearDraftMenuState, () => 0),
);

export function draftReducer(state: number | undefined, action: Action) {
  return _draftReducer(state, action);
}
